// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-media-and-events-card-public {
  background: #fff;
  height: 395px;
  max-width: 300px;
  padding: 1rem;
  border-radius: 12px;
  margin: 0 auto 1.5rem auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
.custom-media-and-events-card-public .custom-media-and-events-card-header {
  background: #f7f7f7;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
}
.custom-media-and-events-card-public .custom-media-and-events-card-header img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
.custom-media-and-events-card-public .custom-media-and-events-card-body {
  margin-top: 0.8rem;
  border-top: 2px solid #ebebeb;
  padding-top: 0.5rem;
  min-height: 119px;
}
.custom-media-and-events-card-public .custom-media-and-events-card-body .media-and-events-card-name {
  color: #525252;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.custom-media-and-events-card-public .custom-media-and-events-card-footer {
  margin-top: 0.7rem;
}
.custom-media-and-events-card-public .custom-media-and-events-card-footer .link-btn {
  border: none;
  background: #fff;
  padding: 0;
}
.custom-media-and-events-card-public .custom-media-and-events-card-footer .link-btn:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/mediaEvent/section/mediaEventsCard.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,0CAAA;AACF;AACE;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACN;AAGE;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AADJ;AAGI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AAHN;AAIM;EACE,aAAA;AAFR","sourcesContent":[".custom-media-and-events-card-public {\r\n  background: #fff;\r\n  height: 395px;\r\n  max-width: 300px;\r\n  padding: 1rem;\r\n  border-radius: 12px;\r\n  margin: 0 auto 1.5rem auto;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\r\n\r\n  .custom-media-and-events-card-header {\r\n    background: #f7f7f7;\r\n    height: 200px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 12px;\r\n\r\n    img {\r\n      width: 100px;\r\n      height: 100px;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  .custom-media-and-events-card-body {\r\n    margin-top: 0.8rem;\r\n    border-top: 2px solid #ebebeb;\r\n    padding-top: 0.5rem;\r\n    min-height: 119px;\r\n\r\n    .media-and-events-card-name {\r\n      color: #525252;\r\n      font-size: 1rem;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      display: -webkit-box;\r\n      -webkit-line-clamp: 5;\r\n      -webkit-box-orient: vertical;\r\n    }\r\n  }\r\n\r\n  .custom-media-and-events-card-footer {\r\n    margin-top: 0.7rem;\r\n\r\n    .link-btn {\r\n      border: none;\r\n      background: #fff;\r\n      padding: 0;\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
